export default __webpack_public_path__ + "static/media/menu_4_aboutus.7aa40a15.jpg";